import axios from 'axios';
import store from '../../store/index';

export default {
	getDrivers() {
		return axios.get(`/api/users?sort=lastName`);
	},
	getDays(from, to) {
		return axios.get(`/api/days?sort=date&from=${from}&to=${to}`);
	},
	getStatistics(users, from, to) {
		return axios.post(`/api/statistics/extraPay`, { users, from, to });
	},
	getCurrency() {
		return axios.get('/api/setup/extraPay_currency');
	},
};
